import React from 'react';
import styles from './SessionExpired.less';
import i18next from 'i18next';
import MUIIcon from '../IconMaterialUI/MUIIcon';

class SessionExpired extends React.Component {

  render() {
    return (
      <div className={styles.sessionExpiredPage + ' container'}>
        <div className={styles.sessionExpiredContainer}>
          <h3 className={styles.heading}>
            <MUIIcon icon={'Warning'} className={`${styles.marterialIcon}`}/>
            <span className={styles.headerSpan}>{i18next.t('error')}</span>
          </h3>
          <div className={`${styles.sessionDiv} form-group`}>
            <p>{i18next.t('sessionExp')}</p>
          </div>
          <h3 className={styles.heading}>
            <MUIIcon icon={'SentimentSatisfied'} className={`${styles.marterialIcon}`}/>
            <span className={styles.headerSpan}>{i18next.t('suggestion')}</span>
          </h3>
          <div className={`${styles.sessionDiv} form-group`}>
            <ul>
              <li>{i18next.t('disabledDblClickMsg')}</li>
              <li>If the problem persists, please try again after clearing the <b>Temporary Files</b> from your web browser.
              </li>
              <li className={styles.a_Tag}><a href="/login">{i18next.t('LoginPageMsg')}</a></li>
            </ul>
          </div>
        </div>
      </div>
    )
  }

}

export default SessionExpired;
